<template>
  <div>
    <div class="maxcontent">
      <b-table
        :items="items"
        :fields="fields"
        id="demandTable"
        per-page="10"
        :current-page="page"
      >
        <template v-slot:cell(createdAt)="row">
          {{ convertDate(row.item.createdAt) }}
        </template>
        <template v-slot:cell(acao)="row">
          <div class="text-center">
            <div v-if="checkSameUser(row.item.user_id)">
              <span
                :id="`edit-demand-${row.item.id}`"
                class="fa fa-edit"
                @click="$bvModal.show(`edit-demand-${row.item.id}`); editDemand(row.item)"
              >
              </span>
              <b-modal
                :id="`edit-demand-${row.item.id}`"
                @ok="updateData"
                size="lg"
                title="Editar Procura de Veículo">
                <b-alert show variant="info">
                  Todos os campos são obrigatórios
                </b-alert>

                  <div class="row">
                    <div class="col-4">
                      <label for="modelo">Modelo</label>
                      <input id="modelo" type="text" v-model="modelo" class="form-control">
                    </div>
                    <div class="col-4">
                        <label for="up">Up</label>
                      <input id="up" type="text" v-model="up" class="form-control">
                    </div>
                    <div class="col-4">
                      <label for="classe">Classe</label>
                      <input id="classe" type="text" v-model="classe" class="form-control">
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-6">
                      <label for="anomodelo">Ano Modelo</label>
                      <input id="anomodelo" type="text" v-model="anomodelo" class="form-control">
                    </div>
                    <div class="col-6">
                      <label for="anofabricacao">Ano Fabricação</label>
                      <input
                        id="anofabricacao"
                        type="text"
                        v-model="anofabricacao"
                        class="form-control"
                      >
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-6">
                      <label for="codigocor">Código Cor</label>
                      <input
                        id="codigocor"
                        type="text"
                        v-model="codigo_cor"
                        class="form-control"
                      >
                    </div>
                    <div class="col-6">
                      <label for="cor">Cor</label>
                      <input id="cor" type="text" v-model="cor" class="form-control">
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-4">
                      <label for="concessionario">Concessionário</label>
                      <input
                        id="concessionario"
                        type="text"
                        v-model="concessionario"
                        class="form-control"
                      >
                    </div>
                    <div class="col-4">
                      <label for="contato">Contato</label>
                      <input id="contato" type="text" v-model="contato" class="form-control">
                    </div>
                    <div class="col-4">
                      <label for="telefone">Telefone</label>
                      <input id="telefone" type="text" v-model="telefone" class="form-control">
                    </div>
                  </div>
              </b-modal>
              <span
                :id="`editDemand-${row.item.id}`"
                class="fa fa-minus"
                @click="removeDemand(row.item.id)"
              >
              </span>
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <b-pagination
      v-model="page"
      :total-rows="items.length"
      per-page="10"
      aria-controls="demandTable"
    ></b-pagination>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import EventBus from '../../../eventBus';

export default {
  name: 'Procura',
  props: {
    items: {
      type: Array,
    },
  },
  data: () => ({
    userAuth: null,
    fields: [
      { key: 'modelo', label: 'Modelo' },
      { key: 'up', label: 'Up' },
      { key: 'classe', label: 'Subsegmento' },
      { key: 'anomodelo', label: 'Ano Modelo' },
      { key: 'anofabricacao', label: 'Ano Fabricação' },
      { key: 'codigo_cor', label: 'Codigo Cor' },
      { key: 'cor', label: 'Cor' },
      { key: 'concessionario', label: 'Concessionário' },
      { key: 'contato', label: 'Nome Contato' },
      { key: 'telefone', label: 'Telefone Contato' },
      { key: 'createdAt', label: 'Data Registro' },
      { key: 'acao', label: 'Editar/Remover' },
    ],
    id: null,
    modelo: null,
    up: null,
    classe: null,
    anomodelo: null,
    anofabricacao: null,
    // eslint-disable-next-line
    codigo_cor: null,
    cor: null,
    concessionario: null,
    contato: null,
    telefone: null,
    page: 1,
  }),
  computed: {
    ...mapState('stockDemand', ['demands']),
  },
  methods: {
    ...mapActions('stockDemand', [
      'getStockDemand',
      'createStockDemand',
      'removeStockDemand',
      'updateStockDemand',
    ]),
    checkSameUser(id) {
      // eslint-disable-next-line eqeqeq
      return (id == this.userAuth.id);
    },
    editDemand(item) {
      const {
        id,
        modelo,
        up,
        classe,
        anomodelo,
        anofabricacao,
        // eslint-disable-next-line
        codigo_cor,
        cor,
        concessionario,
        contato,
        telefone,
        // eslint-disable-next-line
      } = this.items.find(obj => obj.id === item.id);

      this.id = id;
      this.modelo = modelo;
      this.up = up;
      this.classe = classe;
      this.anomodelo = anomodelo;
      this.anofabricacao = anofabricacao;
      // eslint-disable-next-line
      this.codigo_cor = codigo_cor;
      this.cor = cor;
      this.concessionario = concessionario;
      this.contato = contato;
      this.telefone = telefone;
    },
    async updateData() {
      await this.updateStockDemand({
        id: this.id,
        token: this.userAuth.token,
        user_id: this.userAuth.id,
        modelo: this.modelo,
        up: this.up,
        classe: this.classe,
        anomodelo: this.anomodelo,
        anofabricacao: this.anofabricacao,
        // eslint-disable-next-line
        codigo_cor: this.codigo_cor,
        cor: this.cor,
        concessionario: this.concessionario,
        contato: this.contato,
        telefone: this.telefone,
      });
      EventBus.$emit('refresh-demands', true);
    },
    removeDemand(id) {
      this.removeStockDemand({
        token: this.userAuth.token,
        userId: this.userAuth.id,
        id,
      }).then(() => {
        this.getStockDemand({
          filter: null,
        }).then(() => {
          this.items = this.demands;
          this.demand = this.items;
          EventBus.$emit('refresh-demands', true);
        });
      });
    },
    convertDate(date) {
      return (`${date.substring(8, 10)}/${date.substring(5, 7)}/${date.substring(0, 4)}`);
    },
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_pbiAssobens'));
  },
};
</script>

<style>
  .fa {
    background-color: transparent;
    border: none;
    font-size: 25px;
    cursor: pointer;
  }
  .fa-edit {
    color: blue;
  }
  .fa-minus {
    margin-left: 10px;
    color: red;
  }
</style>
